import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/check2_logo.svg";
import "../css/pages/checkComplete.css";
import { ReactComponent as LogoSvg } from "../assets/check2_logo.svg";

const CheckIcon = () => (
  <svg viewBox="0 0 32 32" aria-hidden="true">
    <path d="m8 16.5 5.2 5.2L24.5 10" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 3 5.5 5.7v5.5c0 4.2 2.7 7.9 6.5 9.8 3.8-1.9 6.5-5.6 6.5-9.8V5.7L12 3Z" />
    <path d="m9.2 12 1.8 1.8 3.9-4" />
  </svg>
);

export default function CheckComplete() {
  return (
    <main className="complete-page">
      <div className="complete-glow complete-glow--left" />
      <div className="complete-glow complete-glow--right" />

      <header className="complete-header">
        <Link to="/" aria-label="check² home">
          <Logo />
        </Link>
        <div className="secure-label">
          <ShieldIcon /> Secure verification
        </div>
      </header>

      <section className="complete-shell" aria-labelledby="complete-title">
        <div className="complete-card">
          <div className="success-mark">
            <CheckIcon />
          </div>
          <p className="complete-eyebrow">CHECK SUCCESSFULLY COMPLETED</p>
          <h1 id="complete-title">Thank you, your check is complete.</h1>
          <p className="complete-lead">
            Your identity check has been successfully completed and submitted
            securely. There is nothing else you need to do right now.
          </p>

          {/* <div className="complete-divider" />

          <div className="next-step">
            <span className="next-step-number">1</span>
            <div>
              <h2>What happens next?</h2>
              <p>
                The organisation that invited you will review the completed
                check and contact you directly if they need anything further.
              </p>
            </div>
          </div> */}

          <div className="complete-actions">
            {/* <button className="close-button" onClick={() => window.close()}>
              Close this window
            </button> */}
            <p>You can now safely close this browser window.</p>
          </div>
        </div>

        <aside className="privacy-note">
          <ShieldIcon />
          <div>
            <strong>Your information is protected</strong>
            <span>Encrypted and handled in line with data protection standards.</span>
          </div>
        </aside>
      </section>

      <footer className="footer">
           {/* <div className="container footer_inner">
             <div className="footer_left">
               <LogoSvg />
             </div>
   
             <div className="footer_right">
               <button className="link" onClick={() => scrollTo("features")}>
                 Features
               </button>
               <button className="link" onClick={() => scrollTo("how")}>
                 How it works
               </button>
               <button className="link" onClick={() => scrollTo("cta")}>
                 Get started
               </button>
               <div className="footer_copy">© {year} check²</div>
             </div>
           </div> */}
           <div className="container footer_legal ">
             <div className="footer_copy"></div>
             <div className="footer_copy">
               Rosemount Financial Solutions (IFA) Ltd is authorised and regulated
               by the Financial Conduct Authority (FCA), Firm Reference Number
               535515. Rosemount Financial Solutions (IFA) Ltd is registered in
               England and Wales (Company No: 05668905). Registered Office:
               Rosemount House, 2–4 Chequers Road, Basingstoke, United Kingdom,
               RG21 7PU.
             </div>
             <div className="footer_copy">
               check² is owned and operated by Rosemount Financial Solutions (IFA)
               Ltd and is provided as a verification tool only. It does not
               constitute financial advice or a regulated activity.
             </div>
             <div className="footer_copy">
               For details on how we process personal data, please see our{" "}
               <a
                 href="https://rosemountfs-ifa.co.uk/PrivacyPolicy"
                 target="_blank"
                 rel="noopener noreferrer"
               >
                 Privacy Policy
               </a>
               .
             </div>
           </div>
         </footer>
    </main>
  );
}
